export default __webpack_public_path__ + "static/media/somaliland.5050a187.svg";